// import { FileDatabase, FileSchema } from './../../../models/database';
import {
  CommonModule,
  isPlatformBrowser,
  NgTemplateOutlet,
} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DatabaseDisplayState,
  EditableColumn,
  MetadataPayload,
  SelectedTableDetails,
  SnowColumns,
  ToastMessage,
  SnowDatabases,
  SnowSchema,
  SnowTable,
  FileData,
  FileDatabase,
  FileSchema,
  FileTable,
} from '../../../models/database';
import { DatabaseService } from '../../services/database/database.service';
import { NgbModal, NgbToast, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { finalize, Subject, take, takeUntil, timeout } from 'rxjs';
import { DataShareService } from '../../services/data_share/data-share.service';
import { ToastService } from '../../services/toast/toast.service';
import { FileViewComponentComponent } from '../../shared/file-view-component/file-view-component.component';
import { table } from 'console';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';
 
@Component({
  selector: 'app-tableview-schema',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbToastModule, NgTemplateOutlet],
  templateUrl: './tableview-schema.component.html',
  styleUrl: './tableview-schema.component.scss',
})
export class TableviewSchemaComponent implements OnInit {
  private destroy$ = new Subject<void>();
  databases: string[] = [];
  schemaMap: { [key: string]: string[] } = {};
  tableMap: { [key: string]: string[] } = {};
  columnMap: { [key: string]: SnowColumns[] } = {};
  displayState: DatabaseDisplayState = {};

  // Add these properties for panel collapse functionality
  isLeftPanelCollapsed: boolean = false;
  isMiddlePanelCollapsed: boolean = false;
 
  constructor(
    private router1: ActivatedRoute,
    private router: Router,
    private databaseServices: DatabaseService,
    private cdRef: ChangeDetectorRef,
    private dataSharingService: DataShareService,
    public toastService: ToastService,
    private modalService: NgbModal,
    public loadService: LoadingServiceService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}
 
  selectedDatabase: string | null = null;
  selectedSchema: string | null = null;
  selectedTables: SelectedTableDetails[] = [];
  selectedColumns: SnowColumns[] = [];
  databaseName: string | null = null;
  databaseType: string | null = null;
  uploadedFiles: FileData[] = [];
  selectedFile: any = null;
 
  uploadedFilesStructure: { databases: FileDatabase[] } = { databases: [] };
  showSnowflakeMenu: boolean = false;
  showUploadedFileMenu: boolean = false;
  selectedSource: 'snowflake' | 'uploaded' | 'both' | null = null;
  selectedUploadedTables: SelectedTableDetails[] = []; // For uploaded table selections
  get allSelectedTables(): SelectedTableDetails[] {
    return [...this.selectedTables, ...this.selectedUploadedTables];
  } // Combined table selections
 
  headers = [
    'Column_Name',
    'Data_Type',
    'Is_Nullable',
    'Default_Value',
    'Is_Primary_Key',
    'Is_Unique_Key',
    'Is_Foreign_Key',
  ];
 
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.toastService.showToast('Stage 1 Successfully Completed', {
        classname: 'bg-success text-light',
      });
 
      // this.loadService.show()
 
      this.dataSharingService.uploadResponse$
        .pipe(takeUntil(this.destroy$))
        .subscribe((response) => {
          if (response) {
            this.transformUploadedFiles(response);
          } else {
          }
        });
 
      this.dataSharingService.selectedDatabase$
        .pipe(takeUntil(this.destroy$))
        .subscribe((database) => {
          this.databaseName = database;
          if (this.databaseName) {
            this.selectedSource =
              this.uploadedFiles.length > 0 ? 'both' : 'snowflake';
            this.loadDatabases();
          } else {
            this.selectedSource =
              this.uploadedFiles.length > 0 ? 'uploaded' : null;
            console.log('No Database has been selected');
          }
        });
 
      this.dataSharingService.selectedDatabaseType$
        .pipe(takeUntil(this.destroy$))
        .subscribe((databaseType) => {
          this.databaseType = databaseType;
        });
 
      this.cdRef.detectChanges();
    }
  }
 
  getToolTip(header: string): string {
    const tooltips: { [key: string]: string } = {
      Column_Name: 'Name of the Column',
      Data_Type: 'Data Type (e.g., VARCHAR, INT, BOOLEAN, CHAR...)',
      Is_Nullable: 'Whether this value can be null or not',
      Default_Value: 'What will be the default value if no value is present',
      Is_Primary_Key: 'Is this column is the Primary Key',
      Is_Unique_Key: 'Is this Column has Unique Values',
      Is_Foreign_Key: 'Whether the column is Foreign Key or not',
    };
    return tooltips[header] || '';
  }
 
   // Methods for panel toggle functionality
   toggleLeftPanel(): void {
    this.isLeftPanelCollapsed = !this.isLeftPanelCollapsed;
    this.cdRef.detectChanges();
  }

  toggleMiddlePanel(): void {
    this.isMiddlePanelCollapsed = !this.isMiddlePanelCollapsed;
    this.cdRef.detectChanges();
  }

  loadDatabases() {
    this.loadService.show();
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseServices
      .snowDatabases(this.databaseName)
      .pipe(
        take(1),
        finalize(() => this.loadService.hide()),
        // timeout(30000),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (response) => {
          this.databases = response.databases;
          this.databases.forEach((db) => {
            if (!this.displayState[db]) {
              this.displayState[db] = { isOpen: false, schemas: {} };
            }
          });
          this.cdRef.detectChanges();
        },
        error: (error) => {
          console.error('Error Loading Databases', error);
          this.toastService.showToast(
            'Error loading Databases, due to server error',
            { classname: 'bg-danger text-light' }
          );
          this.cdRef.detectChanges();
        },
      });
  }
 
  loadSchemas(database: string) {
    if (!this.displayState[database]) {
      this.displayState[database] = { isOpen: false, schemas: {} };
      this.cdRef.detectChanges();
    }
    this.displayState[database].isOpen = !this.displayState[database].isOpen;
    this.selectedDatabase = this.displayState[database].isOpen
      ? database
      : null;
    this.selectedSchema = null;
    if (this.displayState[database].isOpen && !this.schemaMap[database]) {
      const sessionID = sessionStorage.getItem('Session_Id');
      this.databaseServices
        .snowSchemas(this.databaseName, database)
        .subscribe((response) => {
          this.schemaMap[database] = response.schemas;
          response.schemas.forEach((schema) => {
            if (!this.displayState[database].schemas[schema]) {
              this.displayState[database].schemas[schema] = { isOpen: false };
            }
          });
          this.cdRef.detectChanges();
        });
    } else if (!this.displayState[database].isOpen) {
      delete this.schemaMap[database];
      this.cdRef.detectChanges();
    }
  }
 
  loadTables(database: string, schema: string) {
    if (!this.displayState[database]) {
      this.displayState[database] = { isOpen: false, schemas: {} };
      this.cdRef.detectChanges();
    }
    if (!this.displayState[database].schemas[schema]) {
      this.displayState[database].schemas[schema] = { isOpen: false };
      this.cdRef.detectChanges();
    }
    this.displayState[database].schemas[schema].isOpen =
      !this.displayState[database].schemas[schema].isOpen;
    this.selectedSchema = this.displayState[database].schemas[schema].isOpen
      ? schema
      : null;
    const key = database + schema;
    if (
      this.displayState[database].schemas[schema].isOpen &&
      !this.tableMap[key]
    ) {
      const sessionID = sessionStorage.getItem('Session_Id');
      this.databaseServices
        .snowTables(this.databaseName, database, schema)
        .subscribe((response) => {
          this.tableMap[key] = response.tables;
          this.cdRef.detectChanges();
        });
    } else if (!this.displayState[database].schemas[schema].isOpen) {
      delete this.tableMap[key];
      this.cdRef.detectChanges();
    }
 
    this.selectedDatabase = database;
    this.selectedSchema = schema;
    this.cdRef.detectChanges();
  }
 
  loadColumnsForSelectedTable(selectedTable: SelectedTableDetails): void {
    const key =
      selectedTable.database + selectedTable.schema + selectedTable.table;
 
    if (selectedTable.source === 'snowflake') {
      // Handle Snowflake tables
      if (!this.columnMap[key]) {
        // const sessionID = sessionStorage.getItem('Session_Id')
        this.databaseServices
          .snowColumns(
            this.databaseName,
            selectedTable.database,
            selectedTable.schema,
            selectedTable.table
          )
          .subscribe({
            next: (response) => {
              this.columnMap[key] = response.table.columns;
              selectedTable.columns = response.table.columns.map((col) => ({
                ...col,
                isEditing: false,
                custom_business_logic: col.custom_business_logic ?? 'none',
              }));
              selectedTable.loading = false;
              this.cdRef.detectChanges();
            },
            error: (error) => {
              console.error('Error loading columns:', error);
              selectedTable.loading = false;
              selectedTable.columnLoadedTimestamp = Date.now();
              this.cdRef.detectChanges();
            },
          });
      } else {
        selectedTable.columns = this.columnMap[key].map((col) => ({
          ...col,
          isEditing: false,
          custom_business_logic: col.custom_business_logic ?? 'none',
        }));
        selectedTable.loading = false;
        selectedTable.columnLoadedTimestamp = Date.now();
        this.cdRef.detectChanges();
      }
    } else if (selectedTable.source === 'uploaded') {
      if (!this.columnMap[key]) {
        // const sessionID = sessionStorage.getItem('Session_Id')
        this.databaseServices
          .fileColumns(
            selectedTable.database,
            selectedTable.schema,
            selectedTable.table
          )
          .subscribe({
            next: (response) => {
              console.log('Column API Resp :', response);
              this.columnMap[key] = response.table.columns;
              selectedTable.columns = response.table.columns.map((col) => ({
                ...col,
                isEditing: false,
                custom_business_logic: col.custom_business_logic ?? 'none',
              }));
              selectedTable.loading = false;
              this.cdRef.detectChanges();
            },
            error: (error) => {
              console.error('Error loading uploaded table columns:', error);
              selectedTable.loading = false;
              selectedTable.columnLoadedTimestamp = Date.now();
              this.cdRef.detectChanges();
            },
          });
      } else {
        selectedTable.columns = this.columnMap[key].map((col) => ({
          ...col,
          isEditing: false,
          custom_business_logic: col.custom_business_logic ?? 'none',
        }));
        selectedTable.loading = false;
        selectedTable.columnLoadedTimestamp = Date.now();
        this.cdRef.detectChanges();
      }
    }
  }
 
  selectTable(database: string, schema: string, table: string) {
    const uniqueId = `${database}.${schema}.${table}`;
    const existingTable = this.allSelectedTables.find(
      (st) => st.uniqueId === uniqueId
    );
    if (existingTable) {
      if (
        existingTable.database === database &&
        existingTable.schema === schema
      ) {
        this.toastService.showToast(
          `Table ${table} is already selected from ${existingTable.database}.${existingTable.schema}`,
          { classname: 'bg-info text-light' }
        );
      } else {
        this.toastService.showToast(
          `Table "${table}" is already selected from a different database ${existingTable.database}.${existingTable.schema}`,
          { classname: 'bg-warning text-light' }
        );
      }
      return;
    }
    const newTable: SelectedTableDetails = {
      database: database,
      schema: schema,
      table: table,
      uniqueId: uniqueId,
      columns: [],
      loading: true,
      source: 'snowflake',
    };
 
    this.selectedTables.push(newTable);
    this.loadColumnsForSelectedTable(newTable);
    this.cdRef.detectChanges();
  }
 
  // Method to handle table selection from uploaded files
  selectUploadedTable(
    dbName: string,
    schemaName: string,
    tableName: string
  ): void {
    const uniqueId = `uploaded.${dbName}.${schemaName}.${tableName}`;
    const existingIndex = this.allSelectedTables.find(
      (t) => t.uniqueId === uniqueId
    );
 
    if (existingIndex) {
      if (
        existingIndex.database === dbName &&
        existingIndex.schema === schemaName
      ) {
        this.toastService.showToast(
          `Table ${tableName} is already selected from ${existingIndex.database}.${existingIndex.schema}`,
          { classname: 'bg-info text-light' }
        );
      } else {
        this.toastService.showToast(
          `Table "${tableName}" is already selected from a different database ${existingIndex.database}.${existingIndex.schema}`,
          { classname: 'bg-warning text-light' }
        );
      }
      return;
    }
    const newTable: SelectedTableDetails = {
      database: dbName,
      schema: schemaName,
      table: tableName,
      uniqueId: uniqueId,
      columns: [],
      loading: true,
      source: 'uploaded',
    };
    this.selectedUploadedTables.push(newTable);
    this.loadColumnsForSelectedTable(newTable);
    this.cdRef.detectChanges();
  }
 
  trackByDatabase(index: number, database: string): string {
    return database;
  }
 
  trackBySchema(index: number, schema: string): string {
    return schema;
  }
 
  trackByTable(index: number, table: string): string {
    return table;
  }
 
  trackBySelectedTable(index: number, table: SelectedTableDetails): string {
    return table.uniqueId + (table.columnLoadedTimestamp || 0);
  }
 
  removeTable(uniqueId: string) {
    // Remove from Snowflake tables
    const snowIndex = this.selectedTables.findIndex(
      (t) => t.uniqueId === uniqueId
    );
    if (snowIndex > -1) {
      this.selectedTables.splice(snowIndex, 1);
      this.cdRef.detectChanges();
      return;
    }
 
    // Remove from Uploaded tables
    const uploadedIndex = this.selectedUploadedTables.findIndex(
      (t) => t.uniqueId === uniqueId
    );
    if (uploadedIndex > -1) {
      this.selectedUploadedTables.splice(uploadedIndex, 1);
      this.cdRef.detectChanges();
    }
 
    this.cdRef.detectChanges();
  }
 
  editColumn(column: EditableColumn) {
    column.isEditing = true;
    
    // Initialize foreign_key_map if needed when entering edit mode
    if (column.is_foreign_key && !column.foreign_key_map) {
      column.foreign_key_map = { table: '', column: '' };
    }
  }

  onForeignKeyToggle(column: EditableColumn) {
    if (column.is_foreign_key) {
      column.foreign_key_map = column.foreign_key_map || { table: '', column: '' };
    } else {
      column.foreign_key_map = null;
    }
    this.cdRef.detectChanges();
  }

  saveColumn(selectedTable: SelectedTableDetails, column: EditableColumn) {
    // Validate foreign key map if is_foreign_key is true
    if (column.is_foreign_key) {
      // Ensure foreign_key_map exists
      if (!column.foreign_key_map) {
        column.foreign_key_map = { table: '', column: '' };
      }
      
      if (!column.foreign_key_map.table || !column.foreign_key_map.column) {
        this.toastService.showToast('Foreign key mapping is required. Please provide both table and column references.', 
          { classname: 'bg-danger text-light' });
        return; // Stop the save process
      }
    } else {
      column.foreign_key_map = null;
    }
  
    // Continue with existing save logic
    column.isEditing = false;
  
    // Find the index of the table and the column
    const tableIndex = this.selectedTables.indexOf(selectedTable);
    if (tableIndex > -1) {
      const columnIndex =
        this.selectedTables[tableIndex].columns?.indexOf(column);
      if (columnIndex && columnIndex > -1) {
        // Update the cached column as well
        const key =
          selectedTable.database + selectedTable.schema + selectedTable.table;
        if (this.columnMap[key] && this.columnMap[key].length > 0) {
          this.columnMap[key][columnIndex] = { ...column };
          this.cdRef.detectChanges();
        }
      }
    }
    this.cdRef.detectChanges();
  }
 
  getGroupedTables(): any[] {
    const groupsMap = new Map<string, any>();
 
    this.allSelectedTables.forEach((table) => {
      const key = `${table.database}|${table.schema}`;
      if (!groupsMap.has(key)) {
        groupsMap.set(key, {
          database: table.database,
          schema: table.schema,
          tables: [],
        });
      }
      groupsMap.get(key)!.tables.push(table);
    });
 
    return Array.from(groupsMap.values());
  }
 
  findTableIndex(table: SelectedTableDetails): number {
    return this.selectedTables.findIndex((t) => t.uniqueId === table.uniqueId);
  }
 
  displayColumns(columns: SnowColumns[] | undefined): (keyof SnowColumns)[] {
    if (columns && columns.length > 0) {
      return Object.keys(columns[0]).filter(
        (key) =>
          key !== 'isEditing' &&
          key !== 'foreign_key_map' &&
          key !== 'custom_business_logic' &&
          key !== 'custom_instruction'
      ) as (keyof SnowColumns)[];
    }
    return [];
  }
 
  // Add this method to identify boolean fields
  isBooleanField(columnName: string): boolean {
    return ['is_nullable', 'is_primary_key', 'is_unique_key', 'is_foreign_key'].includes(columnName.toLowerCase());
  }

  loadUploadedSchemas(dbName: string): void {
    if (!this.displayState[dbName]) {
      this.displayState[dbName] = {
        isOpen: false,
        schemas: {},
      };
    } else {
      this.displayState[dbName].isOpen = !this.displayState[dbName].isOpen;
    }
    this.cdRef.detectChanges();
  }
 
  loadUploadedTables(dbName: string, schemaName: string): void {
    if (!this.displayState[dbName].schemas[schemaName]) {
      this.displayState[dbName].schemas[schemaName] = {
        isOpen: true,
      };
    } else {
      this.displayState[dbName].schemas[schemaName].isOpen =
        !this.displayState[dbName].schemas[schemaName].isOpen;
    }
    this.cdRef.detectChanges();
  }
 
  transformUploadedFiles(apiResponse: any): void {
    this.uploadedFilesStructure = {
      databases: apiResponse.databases.map((db: FileDatabase) => ({
        name: db.name,
        source: 'uploaded',
        schemas: db.schemas.map((schema: FileSchema) => ({
          name: schema.name,
          source: 'uploaded',
          tables: schema.tables.map((table: FileTable) => ({
            name: table.name,
            source: 'uploaded',
          })),
        })),
      })),
    };
 
    // Initialize display state for uploaded files
    this.uploadedFilesStructure.databases.forEach((db) => {
      this.displayState[db.name] = this.displayState[db.name] || {
        isOpen: false,
        schemas: {},
      };
      db.schemas.forEach((schema) => {
        this.displayState[db.name].schemas[schema.name] = this.displayState[
          db.name
        ].schemas[schema.name] || { isOpen: false };
      });
    });
 
    this.cdRef.detectChanges();
  }
 
  SubmitMetadata() {
    if (this.allSelectedTables.length === 0) {
      this.toastService.showToast(`Please select atleast 1 table`, {
        classname: 'bg-warning text-dark',
      });
      return;
    }
 
    const databasesMap = new Map<
      string,
      { schemas: Map<string, { tables: any[] }> }
    >();
 
    this.allSelectedTables.forEach((selectedTable) => {
      if (!databasesMap.has(selectedTable.database)) {
        databasesMap.set(selectedTable.database, { schemas: new Map() });
      }
 
      const databaseEntry = databasesMap.get(selectedTable.database)!;
 
      if (!databaseEntry.schemas.has(selectedTable.schema)) {
        databaseEntry.schemas.set(selectedTable.schema, { tables: [] });
      }
 
      const schemaEntry = databaseEntry.schemas.get(selectedTable.schema)!;
 
      const columnsForApi = selectedTable.columns?.map((column) => {
        const columnData: any = {
          column_name: column.column_name,
          data_type: column.data_type,
          is_nullable: column.is_nullable,
          default_value: column.default_value,
          is_primary_key: column.is_primary_key,
          is_unique_key: column.is_unique_key,
          is_foreign_key: column.is_foreign_key,
          custom_business_logic: column.custom_business_logic,
          custom_instruction: column.custom_instruction,
        };
 
        if (column.is_foreign_key) {
          if (column.foreign_key_map) {
            columnData.references = {
              table: column.foreign_key_map.table,
              column: column.foreign_key_map.column,
            };
          } else {
            columnData.references = null;
          }
        } else {
          columnData.references = null;
        }
        return columnData;
      });
 
      schemaEntry.tables.push({
        table_name: selectedTable.table,
        columns: columnsForApi,
      });
    });
 
    const databasesArray = Array.from(databasesMap.entries()).map(
      ([databaseName, databaseData]) => ({
        database_name: databaseName,
        schemas: Array.from(databaseData.schemas.entries()).map(
          ([schemaName, schemaData]) => ({
            schema_name: schemaName,
            tables: schemaData.tables,
          })
        ),
      })
    );
 
    const apiPayload: MetadataPayload = { databases: databasesArray };
    // console.log("Metadata Payload :", apiPayload )
    // console.log("API payload : ", apiPayload);
    // console.log("Payload being sent : ", JSON.stringify(apiPayload,null,2))
    this.loadService.show();
    // const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseServices
      .storeSnowData(apiPayload)
      .pipe(finalize(() => this.loadService.hide()))
      .subscribe({
        next: (response) => {
          this.router.navigate(['/outputstore']); //, { queryParams: { inputDatabaseName: this.databaseName, metadata: apiPayload } }
        },
        error: (error) => {
          console.error('Error storing Metadata', error);
          this.toastService.showToast(
            'Error saving Metadata due to server Error',
            { classname: 'bg-danger text-light' }
          );
        },
      });
  }
 
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}